<portal-modal-header (onClose)="dismiss()" title="Auth-User"></portal-modal-header>

<portal-modal-body>
  @if (authUser$ | async; as authUser) {
    <form>
      <div class="mb-3">
        <label class="form-label">User</label>
        <div>{{ authUser.username }}</div>
      </div>
      <div class="mb-3">
        <label class="form-label">Role</label>
        <div>{{ authUser.role.name }}: {{ authUser.role.level }}</div>
      </div>
      <div>
        <label class="form-label" for="query">Permissions</label>
        <input
          class="form-control mb-2"
          id="query"
          [portalAutofocus]="true"
          [value]="query"
          (input)="updateFilter($any($event.target).value)"
          name="query"
          placeholder="Search permissions..."
          type="text"
        />
        <ul class="mb-0 list-group">
          @for (permission of permissions; track permission) {
            <li class="list-group-item py-1 px-2">
              <code>{{ permission }}</code>
            </li>
          }
        </ul>
      </div>
    </form>
  }
</portal-modal-body>

<portal-modal-footer [closeOnly]="true" (onCancel)="dismiss()"></portal-modal-footer>
